import { render, staticRenderFns } from "./GBrandSnsForm.vue?vue&type=template&id=2e96aae5&scoped=true&"
import script from "./GBrandSnsForm.vue?vue&type=script&lang=ts&"
export * from "./GBrandSnsForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBrandSnsForm.vue?vue&type=style&index=0&id=2e96aae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e96aae5",
  null
  
)

export default component.exports